import { cn } from "@/lib/utils";
import { ScopeType } from "./types";

interface ScopeSelectorProps {
  selectedScope: ScopeType;
  onSelectScope: (scope: ScopeType) => void;
  shootAndEditPrice: number;
  shootOnlyPrice: number;
  currency?: string;
}

const ScopeSelector = ({
  selectedScope,
  onSelectScope,
  shootAndEditPrice,
  shootOnlyPrice,
  currency = "₹",
}: ScopeSelectorProps) => {
  const RadioRow = ({
    value,
    children,
  }: {
    value: ScopeType;
    children: React.ReactNode;
  }) => {
    const selected = selectedScope === value;

    return (
      <button
        onClick={() => onSelectScope(value)}
        className="flex items-start gap-3 text-left group"
      >
        {/* Radio */}
        <div
          className={cn(
            "mt-[3px] h-[18px] w-[18px] rounded-full border flex items-center justify-center transition",
            selected
              ? "border-primary"
              : "border-muted-foreground/40 group-hover:border-muted-foreground"
          )}
        >
          {selected && (
            <div className="h-[8px] w-[8px] rounded-full bg-primary" />
          )}
        </div>

        {/* Text */}
        <div className="text-sm leading-relaxed">{children}</div>
      </button>
    );
  };

  return (
    <div className="space-y-3">
      {/* Label */}
      <p className="text-sm text-muted-foreground font-medium">
        Choose your scope:
      </p>

      {/* Options */}
      <div className="space-y-2">
        <RadioRow value="shoot_and_edit">
          <span className="font-medium text-foreground">
            Shoot + Edit
          </span>
          <span className="text-muted-foreground">
            {" "}
            — {currency}
            {shootAndEditPrice.toLocaleString()}/video{" "}
            (meets{" "}
            <span className="font-medium text-foreground">
              editing benchmark
            </span>
            )
          </span>
        </RadioRow>

        <RadioRow value="shoot_only">
          <span className="font-medium text-foreground">
            Shoot only
          </span>
          <span className="text-muted-foreground">
            {" "}
            — {currency}
            {shootOnlyPrice.toLocaleString()}/video (raw footage delivery)
          </span>
        </RadioRow>
      </div>
    </div>
  );
};

export default ScopeSelector;